import httpClient from '@xto10x/core/lib/httpClient';

const sheetsIntegrationApi = {
  deleteTracker: (objective_id, version) =>
    httpClient.delete(`/v1/objective-tracker/${objective_id}`, {
      integration_channel: 'GOOGLE_SHEETS',
      objective_version: version
    })
};

export default sheetsIntegrationApi;
